import { Button } from '@mui/material'
import React, { useState, useRef, useEffect, useContext } from 'react'
// import CustomInput from '../../atoms/Inputs/CustomInput'
// import PrimaryButton from '../../atoms/PrimaryButton'
import { currencyFormat } from '@/custom/common/components'
import SettingContext from '@/product/context/setting/settingContext'
import CustomCommonContext from '@/custom/context/common/commonContext'

const CartItem = (props) => {
    const [product, setProduct] = useState()

    const settingcontext = useContext(SettingContext)
    const {
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseTable,
    } = settingcontext
    const { alldata_all_dropdown } = useContext(CustomCommonContext)
    const [userLocation, setUserLocation] = useState('')

    useEffect(() => {
        setProduct(props.data)
        console.log('product here ', props.data)
        // searchTableFetch(
        //     {
        //         limit: 1,
        //         page: 1,
        //         order: '',
        //         orderby: '',
        //         filters: {
        //             project_id: {
        //                 value: props.data.project_id,
        //                 type: 'in',
        //                 field: 'url.project_id',
        //             },
        //             user_id: {
        //                 value: props.data.user_id,
        //                 type: 'in',
        //                 field: 'url.user_id',
        //             },
        //         },
        //         primaryTable: 'user_retrieval_location',
        //     },
        //     'previous_user_location'
        // )
    }, [props.data])

    useEffect(() => {
        console.log('responsehere ', search_fetch_data)
        if (search_fetch_data?.records?.length) {
            search_fetch_data?.records[0]['location_id']
                ?.split(',')
                ?.map((data, index) =>
                    setUserLocation(
                        alldata_all_dropdown[
                            alldata_all_dropdown.findIndex(
                                (ele) => ele.id == data
                            )
                        ]?.description
                    )
                )
        }
    }, [search_fetch_data])

    return (
        <>
            {product ? (
                <>
                    <div className="cartItem d-flex justify-content-between align-items-start">
                        <div className="itemInfo d-flex justify-content-start">
                            <div className="pclImg">
                                <img
                                    src={`${global.images_url}${product.projects_avatar}`}
                                    alt={product.title}
                                />
                            </div>
                            <div className="listContent">
                                <h2 className="listProdTitle">
                                    {product.projects_title}
                                </h2>
                                {props.from == 'cart' ||
                                props.from == 'checkout' ||
                                (props.from == 'invoice' &&
                                    product.buynow_autype === 'live') ? (
                                    <>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Total:</span>
                                                <span>
                                                    {currencyFormat(
                                                        props.amount
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                        </div>

                        <div className="listActBtn"></div>
                    </div>
                </>
            ) : null}
        </>
    )
}
export default CartItem
